export const filtersSelectedDataFormatter = (services) => {
    const selectedServices = services.reduce((acc, service) => {
        if (service?.services?.length > 0) {
            acc[service.id] = service.services.reduce((subAcc, secondLayerService) => {
                subAcc[secondLayerService.id] = secondLayerService?.services?.length > 0 
                    ? secondLayerService.services.map(item => item?.id)
                    : [];
                return subAcc;
            }, {});
        }
        return acc;
    }, {});

    return selectedServices;
};
